type HasMessage = { message: string };

function hasMessage(cause: unknown): cause is HasMessage {
	return typeof cause === 'object' && cause !== null && 'message' in cause;
}

export class EocError extends Error {
	constructor(
		public id: string,
		public cause: unknown,
	) {
		super(`[${id}] ${hasMessage(cause) ? cause.message : cause}`);
		this.name = 'EocError';
	}
}
